/* eslint-disable multiline-ternary */
import styled, { css } from 'styled-components';
import { Col } from '../../base/Grid';
import Typography from '../../base/Typography';

const getSectionVariantBackgroundColor = (theme, variant) => {
  if (variant === 'primary') {
    return theme.colors.primary.blue;
  } if (variant === 'secondary') {
    return theme.colors.neutral.grey95;
  }
  // tertiary
  return theme.colors.neutral.white;
};

const getSectionVariantColor = (theme, variant) => {
  if (variant === 'primary') {
    return theme.colors.neutral.white;
  }
  // tertiary and secondary
  return 'inherit';
};

export const GeneralSection = styled.section`
${({ theme, variant }) => css`
    padding: 0;
    max-width: unset;
    text-align: center;
    background-color: ${getSectionVariantBackgroundColor(theme, variant)};
  `}
`;

export const GeneralSectionCol = styled(Col)`
${({ theme }) => css`
    padding-top: ${theme.spacing(10).rem()} !important;
    padding-bottom: ${theme.spacing(10).rem()} !important;
  `}
`;

export const SectionHeading = styled(Typography)`
${({ theme, variant }) => css`
  && {
    color: ${getSectionVariantColor(theme, variant)} !important;
  }
  `}
`;

export const SectionSubheading = styled(Typography)`
${({ theme, variant }) => css`
  && {
    color: ${getSectionVariantColor(theme, variant)} !important;
  }
  `}
`;
